export const GOOGLE_PLAY_APPS: Record<string, string> = {
    'bmg-ragdoll-car-race': 'https://play.google.com/store/apps/details?id=com.playgama.bmgragdollcarrace',
    'crazy-cart': 'https://play.google.com/store/apps/details?id=com.playgama.crazycart',
    'dress-up-3d': 'https://play.google.com/store/apps/details?id=com.playgama.dressup3d',
    'prison-architect-cage-break-tycoon': 'https://play.google.com/store/apps/details?id=com.playgama.prisonarchitect',
}
